export default {
    driver_performance_implovementPlan_avgEvents: "Promedio de Eventos",
    driver_performance_implovementPlan_riskScore: "Puntuación de Riesgo",
    driver_performance_implovementPlan_totalEvents: "Total de Eventos",
    driver_performance_implovementPlan_totalDistance: "Distancia Total",
    driver_performance_implovementPlan_metric: "Métrica",
    driver_performance_implovementPlan_measure: "Medida",
    driver_performance_implovementPlan_target: "Objetivo",
    driver_performance_implovementPlan_success: "Éxito",
    driver_performance_implovementPlan_byDistance: "Por Distancia",
    driver_performance_implovementPlan_performanceImprovement: "Mejora de Rendimiento",
    driver_performance_implovementPlan_priorCoaching: "Entrenamiento Previo",
    driver_performance_implovementPlan_notes: "Notas",
    driver_performance_implovementPlan_eventName: "Evento",
    driver_performance_implovementPlan_count: "Conteo",
    driver_performance_implovementPlan_updatedCase: "Caso Actualizado",
    driver_performance_implovementPlan_omit: "Omitir",
    driver_performance_implovementPlan_risk: "Riesgo",
    driver_performance_implovementPlan_yes: "Sí",
    driver_performance_implovementPlan_no: "No",
}